export default __webpack_public_path__ + "static/media/ic_israel.bbcea8f1.svg";